export { default as request } from './request'
export { default as requestFile } from './requestFile'
export { default as cookie } from './cookie'

const dotLen = 2
const baseNum = Math.pow(10, dotLen)
export const plusMumber = (num1, num2) => {
  return Math.round((num1 + num2) * baseNum) / baseNum
}

export const getNumProduct = (num1, num2) => {
  return Math.round(num1 * num2 * baseNum) / baseNum
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * 下载文件
 * @param data blobData
 * @param fileName
 */
export function download(data, fileName) {
  if (!data) {
    return
  }
  const blob = new Blob([data], { type: 'application/octet-stream' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.target = '_blank'
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
/**
 * 平级数组转换转换树形数据
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = 'areaCode', pid = 'parentAreaCode') {
  const res = [];
  const temp = {};
  for (let i = 0; i < data.length; i += 1) {
    temp[data[i][id]] = data[i];
  }
  for (let k = 0; k < data.length; k += 1) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]].children) {
        temp[data[k][pid]].children = [];
      }
      temp[data[k][pid]].children.push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

/**
 * 下载文件通过URL下载
 * @param URL
 */
export function downloadFile(URL) {
  const a = document.createElement("a");
  a.href = URL;
  a.download = URL.substring(URL.lastIndexOf("/") + 1);
  a.click();
}
